// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"4e38b23c","450":"8f3365d2","548":"664b707e","569":"73236db4","596":"22619352","702":"954f83bb","979":"3f090099"}[chunkId] + ".chunk.js";
};